import { Box, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import versionNumber from "../../ver.json"

const FooterContent = () => {
  return (
    <>
      <Box className={"BoxStyles"}>
        <Typography variant="caption" color="initial">
          <span className={"version-control"}>Version: {versionNumber.version}</span>
          <Link to={"/PrivacyPolicy"} className={"LinkButton"}>Privacy Policy</Link>
        </Typography>
      </Box>
    </>
  );
};

export default FooterContent;
